import { render, staticRenderFns } from "./WhitelistPresale.vue?vue&type=template&id=097c1d91&scoped=true&"
var script = {}
import style0 from "./WhitelistPresale.vue?vue&type=style&index=0&id=097c1d91&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "097c1d91",
  null
  
)

export default component.exports